import i18n from "@/plugins/i18n"
/**
 * ENUMS like objects
 */

export const COMPONENT_ENUM = {
  SELECTOR: { id: 1, name: "Selector", text: i18n.t("commons.selector") },
  TABLE: { id: 3, name: "Table", text: i18n.t("commons.table") },
  CHECKBOX: { id: 5, name: "Checkbox", text: i18n.t("commons.checkbox") }
}

export const NEXT = {
  FINISH: "Finish",
  DEFAULT: "Next",
  SAVE: "Save and Next"
}

export const STATE_ENUM = {
  EDITABLE: { id: 1 },
  PUBLISHED: { id: 2 },
  REVOKED: { id: 3 },
  SIGNED: { id: 4 },
  LOCKED: { id: 5 }
}

/**
 */
export const STATUS_ITEMS = [
  { text: i18n.t("commons.status.ongoing"), value: "Ongoing" },
  { text: i18n.t("commons.status.pending"), value: "Pending" },
  { text: i18n.t("commons.status.closed"), value: "Closed" },
  { text: i18n.t("commons.status.overdue"), value: "Overdue", disabled: true }
]

// CRITICALITY_ITEMS

export const CRITICALITY_ITEMS = [
  { text: i18n.t("commons.criticality_items.minor"), value: "Minor" },
  { text: i18n.t("commons.criticality_items.major"), value: "Major" },
  { text: i18n.t("commons.criticality_items.critical"), value: "Critical" },
  { text: i18n.t("commons.criticality_items.signal"), value: "Signal" }
]

export const YES_NO_ITEMS = [
  { text: i18n.t("commons.yes"), value: "YES" },
  { text: i18n.t("commons.no"), value: "NO" }
]

export const SIGNATURES_ITEMS = [
  { text: "Performer", value: "performer" },
  { text: "Quality Control", value: "quality_control" },
  { text: "Technical Control", value: "technical_control" },
  { text: "Part A", value: "part_a" },
  { text: "Part B", value: "part_b" },
  { text: "Part C", value: "part_c" },
  { text: "Part D", value: "part_d" }
]

export const QUALITY_POINT_ITEMS = [
  { text: "H", value: "H" },
  { text: "W", value: "W" },
  { text: "R", value: "R" },
  { text: "OTHER", value: "OTHER" }
]

export const STATUS_ITEMS_DISABLED = [
  { text: i18n.t("commons.status.ongoing"), value: "Ongoing" },
  { text: i18n.t("commons.status.pending"), value: "Pending" },
  { text: i18n.t("commons.status.closed"), value: "Closed", disabled: true },
  { text: i18n.t("commons.status.overdue"), value: "Overdue", disabled: true }
]

export const INSPECTION_FORM_MODEL = {
  object: "",
  job: "",
  extra_fields: null
}

export const NON_CONFORMITY_AREAS = {
  WELDING: [
    "Fit-up",
    "Weld defect",
    "Tube-to-tubesheet defect",
    "Weld pre-heating",
    "Weld post-heating",
    "Weld parameter",
    "Welder qualification",
    "Filler material"
  ],
  ACTIVITIES: [
    "Machining",
    "Bending",
    "Rolling",
    "Cutting",
    "Grinding",
    "Tube-to-tubesheet expansion"
  ],
  "NON-DESTRUCTIVE EXAMINATION": [
    "VT examination",
    "Dimensional check",
    "PT examination",
    "MT examination",
    "UT examination",
    "RX film",
    "NDE operator qualification"
  ],
  MATERIALS: [
    "Raw material certificate",
    "Raw material destructive test",
    "Raw material non-destructive test",
    "Raw material PMI"
  ],
  "FINAL OPERATIONS": [
    "Hydraulic test",
    "Pneumatic test",
    "Helium test",
    "Marking",
    "Labelling",
    "Painting",
    "Packing"
  ]
}

export const NOTIFICATION_OBJECTS = { PROJECT: "Project" }
export const PROJECT_MEMBER_ROLES = [
  { text: i18n.t("commons.inspector"), value: "inspector" },
  { text: i18n.t("commons.operator"), value: "operator" }
]
